import { render, staticRenderFns } from "./Grid4.vue?vue&type=template&id=64e438b6&scoped=true&"
import script from "./Grid4.vue?vue&type=script&lang=ts&"
export * from "./Grid4.vue?vue&type=script&lang=ts&"
import style0 from "./Grid4.vue?vue&type=style&index=0&id=64e438b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e438b6",
  null
  
)

export default component.exports